import React from 'react';
import {} from 'react-native';
import Reanimated from 'react-native-reanimated';
import { ILightSpeedOutLeftPresentationProps } from './';

export const LightSpeedOutLeftPresentation: React.FC<ILightSpeedOutLeftPresentationProps> =
  (props) => {
    return (
      <Reanimated.View style={props.containerStyle}>
        {props.children}
      </Reanimated.View>
    );
  };
